import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { operations as lmsManager } from 'store/lmsManager'
import { selectors as licenseSelectors } from 'store/licenseManager'
import { PRODUCTTEACHPAGE } from 'experienceComponents/CreateInstanceShared/constants.js'
import ContentNamespaceGetter from 'layers/content/Hocs/ContentNamespaceGetter'
import { forwardRefWrapped } from 'utils/forwardRefWrapped'
import withSiteContextLite from 'layers/content/v2/Hocs/withSiteContextLite'
import { navigationEvent as navEvent } from 'layers/navigation/store/operations'
import { operations as loadingOperations } from 'store/loadingManager'

const mapStateToProps = state => ({
  activeDigitalLicenses: licenseSelectors.selectActiveDigitalLicenses(state),
  allSites: licenseSelectors.selectActiveSites(state),
  lms: state.lmsManager,
  pathName: state.router.location.pathname,
  userAccess: state.userAccessManager.access,
  userContext: state.userContextManager,
  userProfile: state.userProfileManager,
})

/* istanbul ignore next */
const mapDispatchToProps = dispatch => ({
  createCourseInstanceV2ProgramFlex: async (userContext, classTitle) =>
    dispatch(
      lmsManager.createCourseInstanceV2ProgramFlex(userContext, classTitle),
    ),
  deletingCourseCreatedStatus: async () =>
    dispatch(lmsManager.deletingCourseCreatedStatus()),
  deleteCourseInstance: async courseInstance =>
    dispatch(lmsManager.deleteCourseInstanceV2(courseInstance)),
  fetchInstructorData: async () =>
    dispatch(lmsManager.fetchInstructorProgramFlexGet()),

  updateCourseInstance: async updatedCourseInstance =>
    dispatch(lmsManager.updateCourseInstanceV2(updatedCourseInstance)),
  redirectToMyClasses: (url = PRODUCTTEACHPAGE) => dispatch(push(url)),
  navigationEvent: (url, type) => dispatch(navEvent(url, type)),
  setAppIsLoadingState: text =>
    dispatch(loadingOperations.setIsLoadingState(text)),
  setAppNotLoadingState: () => dispatch(loadingOperations.setNotLoadingState()),
})

export const mapper = (entry, _, ownProps) => {
  const { contentfulCourses: ownPropsCourses = [] } = ownProps || {}
  const { productSubsections: fetchedCourses = [] } = entry || {}

  const contentfulCourses =
    ownPropsCourses.length > 0 ? ownPropsCourses : fetchedCourses
  return { contentfulCourses }
}

const options = { include: 2, mapper, spread: true }

/**
 * Factory function to create a standardized container for CreateInstance components
 * @param {React.Component} Component - The component to wrap with the container
 * @returns {React.Component} - The fully composed HOC component
 */
export const createInstanceContainer = Component => {
  return forwardRefWrapped(
    withSiteContextLite(
      ContentNamespaceGetter(
        Component,
        options,
        'productSection',
        connect(mapStateToProps, mapDispatchToProps),
      ),
    ),
  )
}
